import PropTypes from 'prop-types';
import { CiClock2, CiLocationOn } from 'react-icons/ci';
import { IoChevronDown } from 'react-icons/io5';
import { MdEdit, MdClose } from 'react-icons/md';
import './meeting-dialog.css';
import { initialsOf } from '../../utils/initials';
/**
 * MeetingDetailsDialog component displays the details of a Zoom meeting,
 * including date, duration, join URL, and assigned users. Provides a close button.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.meeting - The meeting object containing details.
 * @param {Array} props.users - The list of all users.
 * @param {Function} props.onClose - Handler to close the dialog.
 */
const MeetingDetailsDialog = ({ meeting, users, onClose,timezone }) => {
  const assignedUsers = users.filter((user) =>
    meeting.emails.includes(user.email),
  );

  console.log('meeting', meeting);

  let startDate;
  if (meeting.start_time) {
    // If start_time exists, use it
    startDate = new Date(meeting.start_time);
  } else if (meeting.date) {
    // Fallback to date if start_time doesn't exist
    startDate = new Date(meeting.date);
  } else {
    // Create a default date if neither exists
    startDate = new Date();
  }

  // Calculate end time based on duration (duration is in minutes)
  const endDate = new Date(
    startDate.getTime() + (meeting.duration || 30) * 60000,
  );

  const dayName = startDate.toLocaleDateString('en-US', { weekday: 'short' });
  const dateStr = startDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };


function convertToTimeZone(utcDateStr, timeZone) {
  // Ensure the string is UTC (ends with Z)
  console.log("utcDateStr-",utcDateStr);
  if (!utcDateStr.endsWith("Z")) {
    utcDateStr = utcDateStr + "Z";
  }

  const utcDate = new Date(utcDateStr);

  // Format only time with AM/PM
  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  }).format(utcDate);
}


  const startTimeStr = convertToTimeZone(meeting.start_time,timezone);
  const endTimeStr = convertToTimeZone(meeting.end_time,timezone);

  return (
    <div className="dialog-overlay">
      <div className="meeting-dialog">
        <div className="dialog-header">
          <div className="header-content">
            <div className="organizer-info">
              <span className="organizer-name">
                {meeting.organizerFname} {meeting.organizerLname}
              </span>
              <span className="organizer-email">
                - {meeting.organizerEmail}
              </span>
            </div>
            <button className="close-btn" onClick={onClose}>
              <MdClose size={16} />
            </button>
          </div>
          <h6 className="meeting-title">{meeting.title}</h6>

          <div className="join-section">
            <a href={meeting.join_url} target="_blank" className="join-btn">
              <span>Join</span>
              <IoChevronDown size={16} />
            </a>
          </div>
        </div>

        <div className="dialog-body">
          <div className="meeting-info">
            <p className="meeting-time">
              <CiClock2 className="icon" />
              {`${dayName} ${dateStr} ${startTimeStr} - ${endTimeStr}`}
            </p>

            <p className="meeting-location">
              <CiLocationOn className="icon" />
              <a
                href={meeting.join_url}
                target="_blank"
                rel="noopener noreferrer"
                className="meeting-link"
              >
                {meeting.join_url}
              </a>
            </p>

            <div className="organizer-section">
              <div className="organizer-avatar">
                <span>
                  {initialsOf(meeting.organizerFname, meeting.organizerLname)}
                </span>
              </div>
              <div className="organizer-details">
                <p className="organizer-text">
                  <strong>
                    {meeting.organizerFname} {meeting.organizerLname} is the
                    organizer.
                  </strong>
                </p>
                <p className="participants-text">
                  {meeting.emails && meeting.emails.length > 0
                    ? `${meeting.emails.join(', ')}.`
                    : 'No participants assigned.'}
                </p>
              </div>
            </div>

            <div className="meeting-description">
              <p>
                {meeting.organizerFname} {meeting.organizerLname} is inviting
                you to a scheduled Zoom meeting. Join Zoom Meeting{' '}
                {meeting.join_url} View m...
              </p>
            </div>
          </div>

          <div className="dialog-actions">
            <button className="edit-btn">
              <MdEdit size={16} />
              Edit
            </button>
            <button className="cancel-btn">
              <MdClose size={16} />
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

MeetingDetailsDialog.propTypes = {
  meeting: PropTypes.shape({
    emails: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    date: PropTypes.instanceOf(Date),
    duration: PropTypes.number,
    join_url: PropTypes.string,
  }),
  users: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.any,
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  ),
  onClose: PropTypes.func,
};

export default MeetingDetailsDialog;
